import React from "react";

function HeartIcon() {
  return (
    <>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ margin: "0 2px" }}
      >
        <path
          d="M7.87109 13.9409C8.00439 13.9409 8.19482 13.8521 8.33447 13.7695C11.9082 11.4844 14.1743 8.82471 14.1743 6.12061C14.1743 3.87354 12.6318 2.28662 10.6387 2.28662C9.40088 2.28662 8.44873 2.97217 7.87109 4.01953C7.30615 2.97852 6.34131 2.28662 5.10352 2.28662C3.11035 2.28662 1.56787 3.87354 1.56787 6.12061C1.56787 8.82471 3.83398 11.4844 7.41406 13.7695C7.54736 13.8521 7.73779 13.9409 7.87109 13.9409Z"
          fill="#F9F2F2"
        />
      </svg>
    </>
  );
}

export default HeartIcon;
